import { Fragment, useEffect, useState } from "react";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { IoMdRefresh } from "react-icons/io";

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';


import { IoMdExpand, IoIosDownload } from "react-icons/io";
import { mediaUrl, cdnUrl, cdnParams } from '../Helpers/General';


function Media( props ){

	const [ mediaElem, setMediaElem] = useState(null);
	const [ mediaType, setMediaType] = useState("");

	const [ isLoading, setIsLoading] = useState(false);

	const defaultLayoutPluginInstance = defaultLayoutPlugin();


	const renderFooter = () => {
		const mediaParams = JSON.parse( props.media.params );
		const cdnPath = `${cdnUrl}${props.media.path}${cdnParams}${props.cdnParams || ''}`;

		return <div className="media-item__footer">

			{ mediaParams.hasOwnProperty('lightbox') && parseInt(mediaParams.lightbox) === 1 &&
				<span 
					data-lightbox
					data-lightbox-src={cdnPath}
					data-lightbox-title={(mediaParams.title !== '' && mediaParams.hasOwnProperty('title') && parseInt(mediaParams.title) === 1) ? props.media.title : ''}
				>
					<IoMdExpand />
				</span>
			}

			{ props.thumb !== true && mediaParams.title !== '' && mediaParams.hasOwnProperty('title') && parseInt(mediaParams.title) === 1 &&
				<small>{props.media.title}</small>
			}

		</div>
	}


	useEffect(() => {

		const cdnPath = `${cdnUrl}${props.media.path}${cdnParams}${props.cdnParams || ''}`;
		const mediaPath = `${mediaUrl}${props.media.path}`;
		const mediaParams = JSON.parse( props.media.params );

		// ----- embeds
		if( 	props.media.embed !== '' ){
			setMediaType('embed');
			setMediaElem( 
				<Fragment>
					<div 	className="media-item" 
							dangerouslySetInnerHTML={{__html:props.media.embed}} 
					/> 

					{renderFooter()}
				</Fragment>
			);
		}

		// ----- audio
		else if( 	props.media.path.includes('.wav') 
					|| props.media.path.includes('.mp3') 
		){
			setMediaType('audio');
			setMediaElem( 
				<Fragment>
					<audio 	className="media-item" 
							src={mediaPath} 
							controls 
							loading="lazy"
					/>

					{renderFooter()}
				</Fragment>
			);
		}

		// ----- image
		else if( 	props.media.path.includes('.jpg') 
					|| props.media.path.includes('.jpeg') 
					|| props.media.path.includes('.png') 
					|| props.media.path.includes('.gif') 
		){
			if( props.loader ){
				setIsLoading(true);
			}

			setMediaType('image');
			setMediaElem( 
				<Fragment>
					<img 	className="media-item" 
							src={cdnPath} 
							alt={props.media.title}
							// onLoad={null}
							ref={(input) => {
								if (!input) { return; }
								input.addEventListener('load', (e) => {
									setIsLoading(false);
								}, {once: true});
								input.addEventListener('error', (e) => {
									setIsLoading(false);
								}, {once: true});
							}}
							loading={ (props.lazyload === true) ? "lazy" : "eager" }
							width="auto"
							height="100%"
							style={props?.style || {}}
					/>

					{renderFooter()}
				</Fragment>
			);
		}

		// ----- documents
		else if( 	props.media.path.includes('.zip') 
					|| props.media.path.includes('.pdf') 
					|| props.media.path.includes('.doc') 
					|| props.media.path.includes('.docx') 
					|| props.media.path.includes('.ppt') 
		){
			setMediaType(
				( mediaParams.hasOwnProperty('lightbox') && parseInt(mediaParams.lightbox) === 1 ) ? 'lightbox' : 'download'
			);
			setMediaElem( 
				<Fragment>
					{ mediaParams.hasOwnProperty('lightbox') && parseInt(mediaParams.lightbox) === 1 && 
						<Fragment>
							<h3 className="media-item__title">{props.media.title}</h3>
							<Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.7.107/build/pdf.worker.min.js`}>
								<Viewer 
									fileUrl={mediaPath} 
									defaultScale={1}
									plugins={[
										defaultLayoutPluginInstance,
									]}
								/>
							</Worker>
						</Fragment>
					}
					{ parseInt(mediaParams.download) === 1 && 
						<a href={mediaPath} download target="_blank" rel="noreferrer">
							<div className="media-item__icon">
								<IoIosDownload width={32} height={32} />
							</div>

							{renderFooter()}
						</a>
					}
				</Fragment>
			);
		}

		// ----- unknown
		else{
			setMediaType('unknown');
			setMediaElem( 
				<span>
					{props.media.path}
				</span>
			);
		}

	// eslint-disable-next-line
	}, [props.media])


	return (
		<div 
			className={`media media--${mediaType} media--loading-${isLoading} `} 
			key={`media_${props.media.id}`}>

			{ props.loader === true && isLoading === true && 
				<IoMdRefresh className="media__loader" width={32} height={32} />
			}

			{ mediaElem !== null &&
				mediaElem
			}
			
		</div>
	);

}

export default Media;